import { createContext } from 'react';
import type { ForsideEpiContent } from '../epitekster/types';

export const ForsideteksterContext = createContext<ForsideEpiContent | null>(null);
